/** Shared format options for artifact download and export dialogs. */

export type ArtifactType = "figure" | "dataframe" | "value";

export interface FormatOption {
  value: string;
  label: string;
  description: string;
}

export const FORMAT_OPTIONS: Record<ArtifactType, FormatOption[]> = {
  figure: [
    { value: "html", label: "HTML", description: "Standalone HTML file with interactive chart" },
  ],
  dataframe: [
    { value: "csv", label: "CSV", description: "Comma-separated values, opens in Excel/Sheets" },
    {
      value: "parquet",
      label: "Parquet",
      description: "Columnar format, efficient for large datasets",
    },
    { value: "zip", label: "ZIP", description: "Compressed archive of partition files" },
  ],
  value: [{ value: "original", label: "Pickle", description: "Python pickle file" }],
};

export const DEFAULT_FORMAT: Record<ArtifactType, string> = {
  figure: "html",
  dataframe: "csv",
  value: "original",
};
